import { useContext, useEffect } from 'react'
import { useTranslations } from '@chilipiper/locale'
import { parseQuery } from '@chilipiper/utils'
import { bookingContext } from './context/bookingContext'

export const usePageTitle = () => {
  const { bookingState: { organizationName = '' } = {} } = useContext(bookingContext)
  const [bookATime] = useTranslations(['bookATime'])

  useEffect(() => {
    const query = parseQuery()
    if (query.rescheduleId) {
      document.title = 'Reschedule Meeting'
    } else {
      document.title = bookATime
      if (!query?.intercom_session) {
        document.title = `${bookATime} | ${organizationName}`
      }
    }
  }, [organizationName, bookATime])
}
